export default {
	SET_MODE: 'SET_MODE'
}
